import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import { LotStatus } from "@/enums/LotStatus";
  import { getStatusText } from "@/v2/helpers/getStatusText";

  interface LotItem {
    id: string;
    title: string;
  }

  interface BuyerData {
    firstBuyer?: string;
    secondBuyer?: string;
  }

  interface Props {
    isOpen: boolean;
    lots: LotItem[];
    status?: string;
    existingBuyers?: BuyerData[];
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BulkSetBuyersModal',
  props: {
    isOpen: { type: Boolean },
    lots: {},
    status: { default: LotStatus.HOLD },
    existingBuyers: {}
  },
  emits: ["close", "confirm", "skip"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;

  const buyersData = ref<Array<{ firstBuyer: string; secondBuyer: string }>>(
    []
  );

  const modalTitle = computed(() => {
    return `Put Lots ${getStatusText(props.status)}`;
  });

  const modalDescription = computed(() => {
    return "Enter buyer name(s) for each lot (optional)";
  });

  const hasAnyBuyers = computed(() => {
    return buyersData.value.some(
      (buyer) => buyer.firstBuyer.trim() || buyer.secondBuyer.trim()
    );
  });

  watch(
    () => props.isOpen,
    (isOpen) => {
      if (isOpen) {
        buyersData.value = props.lots.map((lot, index) => ({
          firstBuyer: props.existingBuyers?.[index]?.firstBuyer || "",
          secondBuyer: props.existingBuyers?.[index]?.secondBuyer || "",
        }));
      }
    }
  );

  const close = () => {
    emit("close");
  };

  const skip = () => {
    emit("skip");
    close();
  };

  const confirm = () => {
    emit("confirm", buyersData.value);
    close();
  };

const __returned__ = { props, emit, buyersData, modalTitle, modalDescription, hasAnyBuyers, close, skip, confirm, ref, watch, computed, Modal, get LotStatus() { return LotStatus }, get getStatusText() { return getStatusText } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})